/** UI language pack tiers (Ustav §25). Generated manifest is source of truth. */
import manifest from './locales/manifest.json'

export const STABLE_UI = new Set<string>(manifest.stable)
export const ALL_UI_PACKS = new Set<string>(manifest.all)
export const BETA_UI = new Set<string>(manifest.beta)
export const RTL_LANGS = new Set<string>(manifest.rtl)

export function uiTier(code: string): 'stable' | 'beta' | 'none' {
  const base = (code.split('-')[0] || code).toLowerCase()
  if (STABLE_UI.has(base)) return 'stable'
  if (ALL_UI_PACKS.has(base) || BETA_UI.has(base)) return 'beta'
  return 'none'
}
